import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_CONFIG = { models: [], trimLevels: [], offers:[] };

const ComparisonContext = React.createContext({
  compareConfig: DEFAULT_CONFIG,
  addModel: () => {console.log('Empty context'); return Promise.resolve();},
  removeModel: () => Promise.resolve(),
  addTrimLevel: () => Promise.resolve(),
  removeTrimLevel: () => Promise.resolve(),
  addOffer: () => Promise.resolve(),
  removeOffer: () => Promise.resolve(),
});

export { ComparisonContext };

const ComparisonProvider = ({ children }) => {
  const [compareConfig, setCompareConfig] = React.useState(DEFAULT_CONFIG);

  React.useEffect(() => {
    // Load from local storage first time we mount
    const localItem = JSON.parse(localStorage.getItem('compareConfig'));
    if (localItem && localItem.models && localItem.trimLevels&&localItem?.offers) {
      setCompareConfig(localItem);
    }
  }, []);

  // const updatePm = ()=>{
  //   setUpdateComparison(uuid());
  // };

  const childConfig = {
    compareConfig,
    // paramID:updateComparison,
    addModel: (slug) => {
      // console.log("Adding slug: " + slug)
      const lConfig = JSON.parse(localStorage.getItem('compareConfig'));
      const oldConfig = (lConfig && lConfig.models && lConfig.trimLevels&&lConfig.offers) ? lConfig : { models: [], trimLevels: [],offers:[] };

      const newValue = {
        trimLevels: [...oldConfig.trimLevels],
        models: [...new Set([...oldConfig.models, slug])],
        offers:[...oldConfig.offers],
      };
      setCompareConfig(newValue);
      localStorage.setItem('compareConfig', JSON.stringify(newValue));
      // updatePm();
      return Promise.resolve();
    },

    removeModel: (slug) => {
      const lConfig = JSON.parse(localStorage.getItem('compareConfig'));
      const oldConfig = (lConfig && lConfig.models && lConfig.trimLevels&&lConfig.offers) ? lConfig : { models: [], trimLevels: [],offers:[] };
      const newValue = {
        trimLevels: [...new Set([...oldConfig.trimLevels.filter(x => x !== slug)])],
        models: [...new Set([...oldConfig.models.filter(x => x !== slug)])],
        offers:[...oldConfig.offers],
      };
      setCompareConfig(newValue);
      localStorage.setItem('compareConfig', JSON.stringify(newValue));
      // updatePm();
      return Promise.resolve();
    },

    addTrimLevel: (slug) => {
      const lConfig = JSON.parse(localStorage.getItem('compareConfig'));
      const oldConfig = (lConfig && lConfig.models && lConfig.trimLevels&&lConfig.offers) ? lConfig : { models: [], trimLevels: [],offers:[] };

      const newValue = {
        trimLevels: [...new Set([...oldConfig.trimLevels, slug])],
        models: [...oldConfig.models],
        offers:[...oldConfig.offers],
      };
      setCompareConfig(newValue);
      localStorage.setItem('compareConfig', JSON.stringify(newValue));
      // updatePm();
      return Promise.resolve();
    },

    removeTrimLevel: (slug) => {
      const lConfig = JSON.parse(localStorage.getItem('compareConfig'));
      const oldConfig = (lConfig && lConfig.models && lConfig.trimLevels&&lConfig.offers) ? lConfig : { models: [], trimLevels: [],offers:[] };

      const newValue = {
        trimLevels: [...new Set([...oldConfig.trimLevels.filter(x => x !== slug)])],
        models: [...new Set([...oldConfig.models.filter(x => x !== slug)])],
        offers:[...oldConfig.offers],
      };

      setCompareConfig(newValue);
      localStorage.setItem('compareConfig', JSON.stringify(newValue));
      // updatePm();
      return Promise.resolve();
    },
    addOffer: (uuid) => {
      const lConfig = JSON.parse(localStorage.getItem('compareConfig'));
      const oldConfig = (lConfig && lConfig.models && lConfig.trimLevels&&lConfig.offers) ? lConfig : { models: [], trimLevels: [],offers:[] };

      const newValue = {
        trimLevels: [...oldConfig.trimLevels],
        models: [...oldConfig.models],
        offers:[...new Set([...oldConfig.offers, uuid])],
      };
      setCompareConfig(newValue);

      localStorage.setItem('compareConfig', JSON.stringify(newValue));
      // updatePm();
      return Promise.resolve();
    },

    removeOffer: (uuid) => {
      const lConfig = JSON.parse(localStorage.getItem('compareConfig'));
      const oldConfig = (lConfig && lConfig.models && lConfig.trimLevels&&lConfig.offers) ? lConfig : { models: [], trimLevels: [],offers:[] };

      const newValue = {
        trimLevels: [...oldConfig.trimLevels],
        offers: [...new Set([...oldConfig.trimLevels.filter(x => x !== uuid)])],
        models: [...oldConfig.models],
      };
      setCompareConfig(newValue);
      localStorage.setItem('compareConfig', JSON.stringify(newValue));
      // updatePm();
      return Promise.resolve();
    },
  };
  return (
    <ComparisonContext.Provider value={childConfig}>{children}</ComparisonContext.Provider>
  );
};

ComparisonProvider.propTypes={
  children: PropTypes.node,
};
export default ComparisonProvider;
